export const sortArrayOfObject = (data: any[], keySortObject: string | number) => {
    return data.sort((a, b) => b[keySortObject].charCodeAt(0) - a[keySortObject].charCodeAt(0))
}